import { ArcLabel } from './ArcLabel'

export const ArcLabelComponent = ArcLabel
export * from './ArcLabelsLayer'
export * from './canvas'
export * from './props'
export * from './useArcLabels'
